import React from 'react';
import { Group, NumberInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useTranslation } from 'react-i18next';
import { ConfigFormValues } from './alertConfigurationConstants.ts';

interface Props {
    form: UseFormReturnType<ConfigFormValues>;
}

const JournalInactivityConditionFields: React.FC<Props> = ({ form }) => {
    const { t } = useTranslation();

    return (
        <Group grow align="flex-start">
            <NumberInput
                label={t('journalInactivityReminder.thresholdDays')}
                description={t('journalInactivityReminder.thresholdDaysDescription')}
                min={1}
                max={30}
                {...form.getInputProps('conditionThresholdDays')}
            />
            <NumberInput
                label={t('journalInactivityReminder.maxReminders')}
                description={t('journalInactivityReminder.maxRemindersDescription')}
                min={1}
                max={10}
                {...form.getInputProps('conditionMaxReminders')}
            />
        </Group>
    );
};

export default JournalInactivityConditionFields;
